export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'I’d had the same novel idea for three years. The Book Blueprint prompts finally gave me a chapter-by-chapter plan, and I’ve written more in six weeks than in the last two years.',
    name: 'Jennifer M.',
    location: 'Columbus, Ohio',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/37d84f5e-f087-43b2-a1c3-b4a9dd6c6851.jpg',
  },
  {
    quote:
      'I was sceptical about using AI for writing. But this isn’t AI writing the book for you — it’s a structure. The Editing Room prompts caught timeline issues in my draft I’d completely missed.',
    name: 'Graham T.',
    location: 'Yorkshire, UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/a22ca455-ee91-413d-b107-24523f91dad8.jpg',
  },
  {
    quote:
      'My characters always felt flat. The Character & World Engine made me actually understand their fears and motivations. My beta readers noticed the difference right away.',
    name: 'Danielle R.',
    location: 'Toronto, Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/b4ffc56a-2ad2-4dd0-89ad-81c51e5b728b.jpg',
  },
];
